import { Service } from '@angular/core';

@Service()
export class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    try {
      const serialized: string = JSON.stringify(value);
      localStorage.setItem(key, serialized);
    } catch (error) {
      console.error(`Error saving to localStorage key "${key}":`, error);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const item: string | null = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error(`Error reading from localStorage key "${key}":`, error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  hasItem(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }
}
